module.exports = __webpack_public_path__ + "img/tree-08-d-leaves.66509de1.png";